import gql from "graphql-tag";
import { apolloCore } from "src/utils/apollo/apollo";
import { Session } from "src/utils/users/types";
import type { ActiveContext } from "shared/ContextSwitcher/store";
import { pick } from "lodash";
import {
  UploadedTablesDocument,
  UploadedTablesQuery,
  UploadedTablesQueryVariables,
} from "src/gql/codegen/graphql";

export const callUploadedTables = (
  session: Session,
  activeContext: ActiveContext
) =>
  apolloCore.query<UploadedTablesQuery, UploadedTablesQueryVariables>({
    query: UploadedTablesDocument,
    context: { session },
    variables: {
      context_owner: pick(activeContext, ["id", "type"]),
    },
    fetchPolicy: "network-only",
  });

gql`
  query UploadedTables($context_owner: ContextOwner) {
    uploaded_tables(context_owner: $context_owner) {
      file_name
      table_name
      status
      is_private
      created_at
    }
  }
`;
